"use client";
import { useContext } from "react";
import ReactDOM from "react-dom";
import RangeSlider from "react-range-slider-input";
import { AppContext } from "./AppContext";
import { deepCopy } from "@/functions/fns";

export default function SpreadRange({ toggleOpen, id, arrayIdx, idx }) {
  const btnRef = document.getElementById(id);
  const { config, setConfig } = useContext(AppContext);
  const { top, left, height } = btnRef.getBoundingClientRect();
  const { start, end } = config[arrayIdx].spread[idx];

  const updateVal = (vals) => {
    const newConfig = deepCopy(config);
    newConfig[arrayIdx].spread[idx].start = vals[0] + "%";
    newConfig[arrayIdx].spread[idx].end = vals[1] + "%";
    setConfig(newConfig);
  };

  return ReactDOM.createPortal(
    <>
      <div className="z fixed inset-0" onClick={toggleOpen} />
      <div className="fixed" style={{ height, left, top }}>
        <div className="border-color absolute right-2 top-1/2 -mt-[75px] h-[150px] rounded border bg-white p-2 dark:bg-dark-900">
          <div className="relative h-full w-full">
            <RangeSlider
              min={0}
              max={150}
              value={[parseInt(start), parseInt(end)]}
              onInput={updateVal}
              className="rslider vertical"
              orientation="vertical"
            />
          </div>
        </div>
      </div>
    </>,
    document.getElementById("root")
  );
}
